

/// <reference path="StockNoteProductLine.ts" />

// Generated class SupplierOrderLine_ManagedObject

class SupplierOrderLine_ManagedObject extends StockNoteProductLine
{
}
